import React, { useEffect, useState } from "react";
import { Grid, Paper, Divider, Typography, IconButton, Tooltip } from "@material-ui/core";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from "@material-ui/core/styles";
import BiztranControls from "../../biztran_controls/BiztranControls";
import ModalFrame from "../../biztran_controls/Modal_Frame";
import ActivityView from "../../crm/Activities/ActivityView";
import CreateActivities from "../../crm/Activities/CreateActivities";
import CreateAttachments from "../../crm/Activities/CreateAttachments";
import CreateNotes from "../../crm/Activities/CreateNotes";
import UseFetchData from "../../../hooks/UseFetchData";

const RelatedData = ({AccountID, AccountName, AccountNoteData, AccountAttachData , AccountActivityData, PopulateData}) => {
    const classes = useStyles();
    const [isOpen, setOpen] = useState(false);
    const [isNoteOpen,setNoteOpen] = useState(false);
    const [rowsNote, setRowsNote] = useState([]);
    const [columnsNote, setColumnsNote] = useState([]);
    const [NoteID,setNoteID] = useState('');
    const [NoteCout,setNoteCout] = useState(0);
    const [ActivityCount,setActivityCount] = useState(0);
    const [response, fetchData] = UseFetchData();

    const openModal = (row) => {
        setNoteID(row);
        setNoteOpen(true);
    }

    useEffect(() => {
        const gridCols = [
          {
            field: "id",
            headerName: ".",
            renderCell: (params) => (<strong> <a href="javascript:;" onClick={() => { openModal(params.id); }} ><EditIcon fontSize="small" /></a> </strong> ), 
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            width: 50,
          },
          {
            field: 'NotesTitle',
            headerName: "Notes Title",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            width: 200,
          },
          {
            field: 'Notes',
            headerName: "Notes",
            headerClassName: "super-app-theme--header",
            headerAlign: "center",
            width: 200,
          },
        ];
        setColumnsNote(gridCols);
       
      }, [response]);
 
      useEffect(() => {
        if(AccountNoteData !== undefined && AccountNoteData.length > 0){
            setRowsNote(AccountNoteData);
            setNoteCout(AccountNoteData.length);
        }
      },[AccountNoteData])
    
    return(
        <div>
            <Paper style={{marginTop: 27, height:200}} elevation={3}>
                <Typography className={classes.headerCmn} noWrap>
                    Activities({ActivityCount})
                    <div style={{ width: "100%" }}>
                        <div style={{ float: "right", marginTop:-12 }}>
                            <Tooltip title="Add Activity">
                                <IconButton onClick={() => {setOpen(true);}}>
                                    <AddCircleOutlineIcon/>
                                </IconButton>
                            </Tooltip>
                        </div>
                    </div>
                </Typography>
                <Divider></Divider>
                <ActivityView 
                    ActivityType="Account"
                    RefDocumentID={AccountID}
                    setActivityCount={setActivityCount}
                    AccountID={AccountID}
                    AccountName={AccountName}
                    PopulateData={AccountActivityData}
                    ActivityData={AccountActivityData}
                />
            </Paper>
            <Paper style={{height:200}} elevation={3}>
                
                <CreateAttachments 
                    RefDocumentID={AccountID} 
                    Group="Account" 
                    AccountAttachData={AccountAttachData}
                />
            </Paper>
            <Paper style={{height:200}} elevation={3}>
                <Typography className={classes.headerCmn} noWrap>
                    Notes({NoteCout})
                    <div style={{ width: "100%" }}>
                        <div style={{ float: "right", marginTop:-12 }}>
                            <Tooltip title="Add Note">
                                <IconButton onClick={() => {setNoteOpen(true);setNoteID('');}}>
                                    <AddCircleOutlineIcon/>
                                </IconButton>
                            </Tooltip>
                        </div>
                    </div>
                </Typography>
                <Divider></Divider>
                <div>
                    <BiztranControls.DataGrid
                        rowHeight={20}
                        headerHeight={20}
                        rows={rowsNote}
                        columns={columnsNote}
                        checkboxSelection={false}
                        hideFooterPagination={true}
                        hideFooter={true}
                        Height="160px"
                        //Height="250px"
                        Width="100%"
                    />
                </div>
            </Paper>
            <ModalFrame
                title="Activity Details"
                maxWidth="md"
                isOpen={isOpen}
                setOpen={setOpen}
            >
                <CreateActivities
                    ActivityType="Account"
                    setOpen={setOpen} 
                    AccountID={AccountID}
                    AccountName={AccountName}
                    PopulateData={AccountActivityData}
                    RefDocumentID={AccountID}
                    DisableUpdate={false}
                    DisableComplete={false}
                    DisableDelete={true}
                    DisableLink="none"
                    DisableCustomer={true}
                    DisableContact={false}
                    DisableRefDoc={false}
                />
            </ModalFrame>
            <ModalFrame
                title="Note Details"
                maxWidth="xs"
                isOpen={isNoteOpen}
                setOpen={setNoteOpen}
            >
                <CreateNotes 
                    setNoteOpen={setNoteOpen} 
                    RefDocumentID={AccountID} 
                    NoteID={NoteID} 
                    AccountNoteData={AccountNoteData}
                    PopulateData={PopulateData} 
                />
            </ModalFrame>
        
        </div>
    );
}

const useStyles = makeStyles((theme) => ({
  headerCmn: {
    height: "1.6rem",
    fontSize: "1rem",
    display: "flex",
    flexDirection: "row",
    margin: "0.3rem",
    fontWeight: "bold",
  },
}));

export default RelatedData;
